module.exports = __webpack_public_path__ + "img/Жамбыл облысы.dd763127.png";